import "../styles/main.scss"
import React from "react"
import Helmet from 'react-helmet';

import slpLogo from '../assets/SLPlogo.jpg'
import renova from '../assets/renova.png'
import sli from '../assets/sli-logo.png'

class IndexComponent extends React.Component {
  componentDidMount() {
    setTimeout(function(){
      document.querySelector('.splash').classList.add('splash--is-active');
    }, 500);
  }

  render() {
    return (
      <div className="splash">
        <Helmet>
          <meta name="twitter:title" content="Sustainable Living Innovations" />
          <meta name="description" content="A joint venture between Renova Capital Partners and Sustainable Living Innovations" />
          <meta name="image" content={slpLogo} />
        </Helmet>

        <div className="splash__content">
          <div className="splash__logo">
            <img src={slpLogo} alt="Logo" />
          </div>

          <div className="splash__info">
            <p>A joint venture between Renova Capital Partners and Sustainable Living Innovations</p>
          </div>

          <div className="splash__renova">
            <a href="https://renovacapitalpartners.com/" target="_blank" className="link--no-style">
              <img src={renova} alt="Renova Logo" />
            </a>

            <a href="http://www.sustainablelivinginnovations.com/index.php" target="_blank" className="link--no-style sli-logo">
              <img src={sli} alt="Sustainable Living Innovations Logo" />
            </a>
          </div>
        </div>
      </div>
    )
  }
}

export default IndexComponent



// WEBPACK FOOTER //
// ./src/pages/index.js